import { NgModule } from "@angular/core";
import { KzMaskDirective } from "../../modules/customer/components/customer/technician-installation/initiation-call-creation/kz-mask.directive";
import { PCalendarDirective } from "./p-calendar.directive";
import { CardMaskDirective } from "./phone-mask/credit-card-number-mask.directive";
import { PhoneMaskDirective } from "./phone-mask/phone-mask.directive";

@NgModule({
  declarations: [PhoneMaskDirective, CardMaskDirective, PCalendarDirective,KzMaskDirective,],
  exports: [PhoneMaskDirective, CardMaskDirective, PCalendarDirective,KzMaskDirective,],
})
export class AllDirectivesModule { }